'use strict';

var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
var Tab = require('../../../node_modules/@material-ui/core/esm/Tab/Tab.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PillTab = withStyles["default"](function (theme) {
  return {
    root: {
      textTransform: 'none',
      color: theme.palette.black.primary,
      height: '32px',
      minHeight: '32px',
      borderRadius: '100px',
      backgroundColor: theme.palette.secondary[200]
    },
    selected: {
      backgroundColor: theme.palette.white.primary
    }
  };
})(function (props) {
  return React__default["default"].createElement(Tab["default"], props);
});

module.exports = PillTab;
